var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"breadcrumb flex row align-center"},[_c('div',{staticClass:"parent"},[_vm._v("What we do")]),_c('div',{staticClass:"arrow"}),_c('div',{staticClass:"child"},[_vm._v(_vm._s(_vm.page))])])
}
var staticRenderFns = []

export { render, staticRenderFns }